import React, { useState, useEffect, useContext } from 'react';
import UserContext from '../../components/User_Context.js';
import * as menu from "../../assets/menus/menu.js"
import waiting from "../../assets/images/waiting.svg";
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import * as breadcrumb from "../../components/ui/breadcrumb.js";
import * as utils from "../../components/utils.js";
import * as api from "../../api/apiConnector.js";
import ActivityUserLink from '../../components/activity_user_link.js';
import { useTranslation } from 'react-i18next';
import { ActivitiesLabels } from '../_label/activities/activities_labels.js';
const Board_Screen = (params) => {
    const { t } = useTranslation();

    const { currentUser } = useContext(UserContext);
    const [boards, setBoards] = useState(null);
    const [preferredBoard, setPreferredBoard] = useState(null);
    const [currentBoard, setCurrentBoard] = useState(null);
    const [draggingNode, setDraggingNode] = useState(null);
    const [droppingNode, setDroppingNode] = useState(null);
    const [droppingPosition, setDroppingPosition] = useState(null);
    const [dragEnabledCards, setDragEnabledCards] = useState(new Set());

    useEffect(() => {

        (async () => {
            // Initialize i18n labels from centralized file
            const i18n = menu.getI18n();
            i18n.addResourceBundle('it', 'labels', ActivitiesLabels.it, true, true);
            i18n.addResourceBundle('en', 'labels', ActivitiesLabels.en, true, true);
            
            setBreadCrumb();
            menu.write({ user: currentUser() });
            await retrieveData();

        })();
    }, []);

    useEffect(() => {
        if (boards && preferredBoard) {

            boards.forEach((board, index) => {
                if (board.Order != index) {
                    board.Order = index;


                    saveOrderAndPreferred(board);

                }
            });

            preferredBoard.forEach((preferredBoard, index) => {
                if (preferredBoard.Order != index) {
                    preferredBoard.Order = index;


                    saveOrderAndPreferred(preferredBoard);

                }
            });

            _drawBoards();

            const type = window.$("div[data-root-node]").attr("data-root-node");
            window.$("div[data-id]").draggable({
                opacity: 0.9,
                cursor: "move",
                containment: window.$(`div[data-root-node='${type}']`),
                revert: "invalid",
                helper: function (event) {
                    const titleBoardElement = window.$(this).find('[data-property="titleBoard"]');
                    const titleBoardText = titleBoardElement.text();

                    const descirptionBoardElement = window.$(this).find('[data-property="descriptionBoard"]');
                    const descriptionBoardText = descirptionBoardElement.text();

                    const originalElement = window.$(this); // Salva l'elemento originale
                    const originalWidth = originalElement.outerWidth();
                    const originalHeight = originalElement.outerHeight();

                    const copyDiv = window.$(`<div class="copy-board-card" style="width:${originalWidth},">
                                <div class="copy-board-card-header">
                                  ${titleBoardText}
                                </div>
                                <div class="copy-board-card-body">
                                 <p> ${descriptionBoardText} </p>
                                
                            </div>
                           
                            </div>`);

                    copyDiv.width(originalWidth);
                    copyDiv.height(originalHeight);
                    window.$(copyDiv).css("z-index", 1000);
                    // window.$(".activityCard").css("height", "250px");
                    // window.$(".activityCard").css("width", "250px");

                        // transition: All 1s ease-in-out;
                    

                     return (copyDiv);

                },
                start: (e, ui) => {
                    // Check if drag is enabled using data attribute
                    const isDragEnabled = window.$(e.target).attr('data-drag-enabled') === 'true';
                    if (!isDragEnabled) {
                        return false; // Prevent drag
                    }
                    
                    window.$(e.target).css("z-index", 1000);
                    window.$(e.target).css('cursor', 'grabbing');

                    if (type == 'preferred') {
                        setDraggingNode(preferredBoard.find(x => x.Id == window.$(e.target).attr("data-id")));
                    } else {
                        setDraggingNode(boards.find(x => x.Id == window.$(e.target).attr("data-id")));
                    }
                },

                stop: (e) => {
                    window.$(e.target).css("z-index", 0);
                    window.$(e.target).css('cursor', 'grab');
                },
                
                // axis: "y"
            });

            window.$("div[data-id]").droppable({
                over: (e, ui) => {
                },
                out: (e, ui) => {
                    // window.$(e.target).find("td").removeClass("table-primary");
                },
                drop: (e, ui) => {
                    let dropNode = boards.find(x => x.Id == window.$(e.target).attr("data-id"));

                    if (dropNode == null) {
                        dropNode = preferredBoard.find(x => x.Id == window.$(e.target).attr("data-id"));
                    }
                    
                    // Don't allow dropping on the same element
                    const draggedId = ui.draggable.attr("data-id");
                    if (dropNode && dropNode.Id == draggedId) {
                        return;
                    }
                    
                    console.log('Setting dropping board node:', dropNode?.Name, 'ID:', dropNode?.Id);
                    setDroppingNode(dropNode);

                    // Calculate drop position based on mouse position relative to the card center
                    const cardElement = window.$(e.target).closest('[data-id]');
                    const cardOffset = cardElement.offset();
                    const cardWidth = cardElement.outerWidth();
                    
                    // Use the actual mouse position at drop time
                    const mouseX = e.pageX || (e.originalEvent && e.originalEvent.pageX) || ui.position.left + ui.draggable.outerWidth()/2;
                    const cardCenterX = cardOffset.left + (cardWidth / 2);
                    
                    const dropPosition = mouseX < cardCenterX ? 'left' : 'right';
                    
                    console.log('Board Drop Debug:', {
                        draggedId,
                        dropNodeId: dropNode?.Id,
                        mouseX,
                        cardCenterX,
                        cardOffset: cardOffset.left,
                        cardWidth,
                        dropPosition
                    });
                    
                    setDroppingPosition(dropPosition);
                    ui.draggable.css('transform', '');
                }
            });
            window.$("div[data-root-node]").droppable({
                drop: (e, ui) => {
                    //setDroppingNode({ Id: null });
                    //ui.draggable.animate({ left: 0, top: 0 }, 250);
                    ui.draggable.css('transform', '');

                }
            });


        }
    }, [boards, preferredBoard, dragEnabledCards]);


    useEffect(() => {
        if (draggingNode && droppingNode && droppingPosition) {

            console.log('Processing board reorder operation...');

            const originalList = draggingNode.Preferred ? preferredBoard : boards;
            
            // CREATE A COPY FIRST - DON'T MUTATE ORIGINAL STATE
            const boardToChange = utils.clone(originalList);

            // Find indices BEFORE removing the dragged item
            const draggedIndex = boardToChange.findIndex(x => x.Id == draggingNode.Id);
            const droppingIndex = boardToChange.findIndex(board => board.Id === droppingNode.Id);

            console.log('Board Reorder Debug:', {
                draggingNodeId: draggingNode.Id,
                draggingNodeName: draggingNode.Name,
                droppingNodeId: droppingNode.Id,
                droppingNodeName: droppingNode.Name,
                droppingPosition,
                draggedIndex,
                droppingIndex,
                listLength: boardToChange.length,
                listNames: boardToChange.map(x => x.Name)
            });

            // Calculate final position
            let finalPosition;
            switch (droppingPosition) {
                case "left":
                    finalPosition = droppingIndex;
                    break;
                case "right":
                    finalPosition = droppingIndex + 1;
                    break;
                default:
                    finalPosition = droppingIndex;
                    break;
            }

            // FIXED: Adjust final position if dragged item is before the final position
            // When we remove an item, indices shift, so we need to account for that
            if (draggedIndex < finalPosition) {
                finalPosition = finalPosition - 1;
            }

            console.log('Final position calculated:', finalPosition);

            // Remove the dragged item
            boardToChange.splice(draggedIndex, 1);

            // Insert at correct position
            boardToChange.splice(finalPosition, 0, { ...draggingNode });

            // UPDATE ORDER PROPERTIES TO MATCH NEW POSITIONS
            boardToChange.forEach((item, index) => {
                item.Order = index;
            });

            console.log('After reorder:', boardToChange.map(x => x.Name));
            console.log('Updated Orders:', boardToChange.map(x => ({ name: x.Name, order: x.Order })));

            // Update state with the new array
            if (draggingNode.Preferred) {
                setPreferredBoard(boardToChange);
            }
            else {
                setBoards(boardToChange);
            }

            // Simple immediate reset
            setDraggingNode(null);
            setDroppingNode(null);
            setDroppingPosition(null);
            setDragEnabledCards(new Set());
        }

    }, [droppingNode, draggingNode, droppingPosition]);


    const setBreadCrumb = (params) => {
        var path = [{
            link: "/",
            name: t("menu.main")
        },
        {
            link: "/activity/board",
            name: t("menu.activities.boards")
        }
        ];
        breadcrumb.set(path);
    }


    const toggleDragMode = (boardId) => {
        console.log('Toggle drag mode for board:', boardId);
        setDragEnabledCards(prev => {
            const newSet = new Set(prev);
            if (newSet.has(boardId)) {
                newSet.delete(boardId);
            } else {
                newSet.add(boardId);
            }
            return newSet;
        });
    };

    const saveOrderAndPreferred = async (board) => {

        const board_result = api.sendMessage("activity/board/saveBoardOrderAndPreferred", {
            user: currentUser(),
            body: {
                board: board
            }
        })
    }

    const retrieveData = async () => {

        const result = await api.sendMessage("activity/board/getAllBoardsForUser", {
            user: currentUser(),

        });

        const preferredBoard = result.boards.filter(x => x.Preferred).sort((a, b) => { return (a.Order - b.Order || a.Name.localeCompare(b.Name)) })
        const normalBoard = result.boards.filter(x => !x.Preferred).sort((a, b) => { return (a.Order - b.Order || a.Name.localeCompare(b.Name)) })

        setBoards(normalBoard);
        setPreferredBoard(preferredBoard);


    }

    const _drawBoardsType = (type) => {

        let boardsToDraw;

        switch (type) {
            case "preferred": {
                boardsToDraw = preferredBoard;
                break;
            }

            default: {
                boardsToDraw = boards;
                break;

            }
        }

        // Always show the container and new card button, even if there are no boards
        return (<div data-root-node={type} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))" }}>
            {boardsToDraw && boardsToDraw.length > 0 && boardsToDraw.map(x => {
                return _drawCard(x);
            })}
            {_drawNewCard(type)}
        </div>);

    }

    const _drawNewCard = (type) => {
        return (
            <div className='row me-2'>
                <div className="card activityCard col-md-12">
                    <div className="card-body d-flex align-items-center justify-content-center">
                        <button className="btn btn-sm btn-success" onClick={() => {
                            const preferred = (type == 'preferred') ? true : false;
                            const newBoard = {
                                Preferred: preferred
                            };
                            setCurrentBoard(utils.clone(newBoard));
                        }} >{t("addNewBoard", { ns: "labels" })}</button>
                    </div>
                </div>
            </div>
        )
    }

    const showDeleteBoardModal = (board) => {
        withReactContent(Swal).fire({
            title: t("areYouSure", { ns: "labels" }),
            icon: "warning",
            text: t("areYouSureDeleteBoard", { ns: "labels" }, { boardName: board.Name }),
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: t("yes", { ns: "labels" }),
            cancelButtonText: t("no", { ns: "labels" }),
            confirmButtonColor: "#DD6B55",


        }).then(async (result) => {
            if (result.isConfirmed) {
                deleteBoard(board);
                withReactContent(Swal).close();

            }
        });
    };

    const deleteBoard = async (board) => {

        const delete_result = await api.sendMessage("activity/board/deleteBoard", {
            user: currentUser(),
            body: { boardId: board.Id }
        });


        if (delete_result.message) {
            withReactContent(Swal).fire({
                title: t('error', { ns: 'labels' }),
                icon: "error",
                text: delete_result.message,
                showConfirmButton: true
            });
        }
        else {
            withReactContent(Swal).fire({
                title: t('deleted', { ns: 'labels' }),
                icon: "success",
                text: t("boardDeletedCorrectly", { ns: "labels" }, { boardName: delete_result.boards[0].Name }),
                showConfirmButton: true,
                timer: 1500
            });


            if (board.Preferred) {
                preferredBoard.splice(preferredBoard.findIndex(x => x.Id === board.Id), 1);
                setPreferredBoard(utils.clone(preferredBoard));
            }
            else {
                boards.splice(boards.findIndex(x => x.Id === board.Id), 1);
                setBoards(utils.clone(boards));

            }
        }

    }

    const saveBoard = async (boardToSave) => {

        withReactContent(Swal).fire({
            title: t('info', { ns: 'labels' }),
            icon: "info",
            text: t('savingData', { ns: 'labels' }),
            showConfirmButton: true,
            timer: 1500
        });

        if (boardToSave.Name && boardToSave.Name != '') {

            const result = await api.sendMessage("activity/board/saveBoard", {
                user: currentUser(),
                body: { boardToSave: boardToSave }
            });

            if ((result.boards.length + result.links.length) > 0) {

                for (const b of result.boards) {
                    const links = result.links.find(x => x.ActivityBoardId == b.Id);

                    if (b.Preferred) {
                        if (boardToSave.Id) {
                            preferredBoard.splice(preferredBoard.findIndex(x => x.Id === boardToSave.Id), 1);
                        }
                    } else {
                        if (boardToSave.Id) {
                            boards.splice(boards.findIndex(x => x.Id === boardToSave.Id), 1);
                        }

                    }

                    if (links) {
                        b.Preferred = links.Preferred
                    }

                    if (b.Preferred) {
                        preferredBoard.push(b);
                    } else {

                        boards.push(b);
                    }


                }

                setBoards(utils.clone(boards));
                setPreferredBoard(utils.clone(preferredBoard));

            }
            else {
                withReactContent(Swal).fire({
                    title: t('oooops', { ns: 'labels' }),
                    icon: "error",
                    text: t('thereAreSomeProblems', { ns: 'labels' }),
                    showConfirmButton: true
                });
            }

        }
        else {
            return {
                success: false,
                message: t('nameIsEmpty', { ns: 'labels' })

            }
        }




    }

    const editModal = () => {

        const _localUpdate = () => {
            currentBoard.__localUpdate = true;
            setCurrentBoard(utils.clone(currentBoard));
        }

        if (currentBoard) {
            return (
                <>
                    <div class="modal-backdrop fade show"></div>
                    <div id="business_unit_edit_modal" className="modal fade show" style={{ display: "block" }} >
                        <div className="modal-dialog modal-xl  modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{currentBoard.Name}</h5>
                                    <button type="button" className="btn-close" aria-label="Close"
                                        onClick={(e) => {
                                            setCurrentBoard(null);
                                        }}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div>
                                        <label for="item_code" className="form-label">{t('name', { ns: 'labels' })}</label>
                                        <input id="item_code" type="text" className="form-control" value={currentBoard.Name}
                                            onChange={(e) => {
                                                currentBoard.Name = e.target.value;
                                                _localUpdate();
                                            }}
                                            placeholder={t('name', { ns: 'labels' })} />
                                    </div>
                                    <br></br>
                                    <div>
                                        <label for="item_code" className="form-label">{t('description', { ns: 'labels' })}</label>
                                        <input id="item_code" type="text" className="form-control" value={currentBoard.Description}
                                            onChange={(e) => {
                                                currentBoard.Description = e.target.value;
                                                _localUpdate();
                                            }}
                                            placeholder={t('description', { ns: 'labels' })} />
                                    </div>
                                    <br></br>
                                    {/* <ActivityUserLink></ActivityUserLink> */}
                                </div>



                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary"
                                        onClick={(e) => {
                                            setCurrentBoard(null);
                                        }}
                                    >{t('close', { ns: 'labels' })}</button>
                                    <button type="button" onClick={(e) => {

                                        saveBoard(currentBoard);
                                        setCurrentBoard(null);
                                    }}
                                        className="btn btn-primary" disabled={currentBoard.Name ? null : true}>{t('ok', { ns: 'labels' })}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
        else {
            return (null);
        }

    }


    const changePreferred = async (board) => {

        const realBoardPreviousValue = board.Preferred;
        const messageToShow = realBoardPreviousValue ? 'in the other boards' : 'in the favourite boards';

        if (board.Preferred) {
            preferredBoard.splice(preferredBoard.findIndex(x => x.Id == board.Id), 1);
            board.Preferred = !realBoardPreviousValue;
            boards.push(board);

        }
        else {
            boards.splice(boards.findIndex(x => x.Id == board.Id), 1);
            board.Preferred = !realBoardPreviousValue;
            preferredBoard.push(board);
        }

        withReactContent(Swal).fire({
            title: t('info', { ns: 'labels' }),
            icon: "info",
            text: `Moving ${board.Name} ${messageToShow}`,
            showConfirmButton: true,
            timer: 1500
        });

        setPreferredBoard(utils.clone(preferredBoard));
        setBoards(utils.clone(boards));
        
        // Save the preference change to backend
        await saveOrderAndPreferred(board);

    }

    const _drawCard = (board) => {
        return (
            <div className='row me-2'>
                <div 
                    className={`card activityCard col-md-12 draggable-card ${dragEnabledCards.has(board.Id) ? 'drag-enabled' : ''}`}
                    data-id={board.Id} 
                    data-position="center"
                    data-drag-enabled={dragEnabledCards.has(board.Id) ? 'true' : 'false'}
                    style={{ 
                        cursor: dragEnabledCards.has(board.Id) ? 'grab' : 'pointer',
                        border: dragEnabledCards.has(board.Id) ? '2px dashed #007bff' : 'none',
                        opacity: dragEnabledCards.has(board.Id) ? 0.8 : 1
                    }}
                    onClick={(e) => {
                        // Prevent triggering when clicking on buttons or dropdowns
                        if (e.target.closest('.dropdown, .btn, button')) {
                            return;
                        }
                        e.preventDefault();
                        e.stopPropagation();
                        toggleDragMode(board.Id);
                    }}
                >
                    
                    <div className="card-body "
                        onDoubleClick={() => {
                            window.location.href = `/activity/activityList/${board.Id}`;
                        }}
                    >
                        <div className='row'>
                            <h5 data-property="titleBoard" className="card-title col">{board.Name}</h5>

                            <div className="dropdown ms-auto text-end c-pointer threedot" data-bs-toggle="dropdown" aria-expanded="false">
                                <div className="btn-link threedotDiv" >
                                    <i className="fas fa-ellipsis-v" style={{ marginRight: "0.9em" }}></i>
                                </div>
                                <div className="dropdown-menu dropdown-menu-end">
                                    <button onClick={() => {
                                        setCurrentBoard(board);
                                    }} className="dropdown-item"><i className="fas fa-pencil-alt me-2"></i>{t("edit", { ns: "labels" })}</button>

                                    <button onClick={() => {
                                        showDeleteBoardModal(board);
                                    }} className="dropdown-item"><i className="fa fa-trash me-2"></i>{t("delete", { ns: "labels" })}</button>
                                </div>
                            </div>
                        </div>
                        <p className="card-text" data-property="descriptionBoard">{board.Description}</p>
                        <button 
                            onClick={() => {
                                window.location.href = `/activity/activityList/${board.Id}`;
                            }} 
                            className="btn btn-sm btn-primary"
                        >
                            {t("openBoard", { ns: "labels" })}
                        </button>
                        <button className="btn btn-link float-end" style={{ padding: 0 }}
                            onClick={(e) => {
                                changePreferred(board);
                            }}
                        >
                            <i className="fas fa-heart"
                                style={{ color: (board.Preferred ? 'red' : 'lightblue' ), borderColor:'red'}} ></i>
                        </button>
                    </div>
                </div>
            </div>
        )
    }


    const _drawBoards = () => {

        return (<>
            <div>
                <h6>{t("preferredBoards", { ns: "labels" })}</h6>
                <p>{t("hereYouCanFindYourPreferredBoards", { ns: "labels" })}</p>
                {_drawBoardsType("preferred")}
            </div>
            <div>
                <h6>{t("otherBoards", { ns: "labels" })}</h6>
                <p>{t("hereYouCanFindOtherBoards", { ns: "labels" })}</p>

                {_drawBoardsType()}
            </div>
        </>
        )
    }


    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                </ol>
                <div>
                    {/* 

                    <a className="text-primary fs-13" onClick={(e) => {
                        // _saveIndicatorEvaluation();
                    }} role="button" title="Save data"><i className="fa-solid fa-floppy-disk fa-2x"></i></a> */}
                </div>
            </div>

            <div style={{
                width: "100%",
                overflow: "scroll"

            }}>
            </div>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="tab-content" id="tabs-content" style={{ padding: 15 }}>
                                    {boards ? (
                                        <>
                                            {_drawBoards()}
                                            {editModal()}
                                        </>) : <div className="text-center"><img src={waiting} /></div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default Board_Screen